import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

import { StateDTO } from "../../shared/models/state-dto";
import { StateAutoCompleteFiltersDTO } from "src/app/shared/models/state-auto-complete-filters-dto";

@Injectable({
  providedIn: "root"
})
export class StateService {
  private stateUrl = "states/";

  constructor(private http: HttpClient) {}

  listAll(): Observable<StateDTO[]> {
    return this.http.get<StateDTO[]>(environment.apiUrl + this.stateUrl);
  }

  findById(id: number): Observable<StateDTO> {
    return this.http.get<StateDTO>(
      environment.apiUrl + `${this.stateUrl}${id}`
    );
  }

  findByCountryId(countryId: number): Observable<StateDTO[]> {
    return this.http.get<StateDTO[]>(
      environment.apiUrl + `${this.stateUrl}filters?countryId=${countryId}`
    );
  }

  findByFilters(filters: StateAutoCompleteFiltersDTO): Observable<StateDTO[]> {
    let query = "?";

    if (filters.name) {
      query += `&name=${filters.name}`;
    }
    if (filters.countryId) {
      query += `&countryId=${filters.countryId}`;
    }

    return this.http.get<StateDTO[]>(
      environment.apiUrl + `${this.stateUrl}filters${query}`
    );
  }
}
